import { convertDateInputToPayload } from "../../functions/convert";

export const CallOtp = (value) => {
  return {
    telephone: value.telephone,
  };
};
export const VerifyOtp = (value) => {
  return {
    otpCode: value.otpCode,
    otpRef: value.otpRef,
    telephone: value.telephone,
    lineUid: value.lineUid,
    lineName: value.lineName,
    isPolicyAccept: true,
  };
};
export const InsertWarranty = (value) => {
  return {
    invImage: value.invImage ? value.invImage.originFileObj : null,
    packageImage: value.packageImage ? value.packageImage.originFileObj : null,
    telephone: value.telephone,
    fullName: value.fullName,
    mobileBrandId: value.mobileBrandId,
    mobileModelName: value.mobileModelName,
    channelBuyId: value.channelBuyId,
    productId: value.productId,
    warrantyNumberCode: value.warrantyNumberCode,
    purchaseDate: convertDateInputToPayload(value.purchaseDate),
  };
};
export const InsertClaim = (value) => {
  return {
    claimImage: value.claimImage ? value.claimImage.originFileObj : null,
    receiptImage: value.receiptImage ? value.receiptImage.originFileObj : null,
    warrantyId: value.warrantyId,
    customerCode: value.customerCode,
    detail1: value.detail1,
    detail2: value.detail2,
    breakdownId: value.breakdownId,
    breakdownSubId: value.breakdownSubId,
    addressLine1: value.addressLine1,
    addressLine2: value.addressLine2,
    subDistrictId: value.subDistrictId,
    zipcode: value.zipcode,
    other: value.other,
    isCreateNewAddress: value.isCreateNewAddress,
  };
};
